module.exports = __webpack_public_path__ + "static/media/5a.6a8ffafc.jpg";